/*
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-12 09:55:58
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-01-05 10:47:10
 * @Description: description
 */
export const tipsMixin = {
  data() {
    return {
      caseShareTips: "分享最新的动态资讯",
      forumTips:
        "发布讨论会议的安排，邀请感兴趣的成员加入，是专业人士交流思想、提升专业知识的场所",
      loudSpeakerTips: "用于通知用户重要的信息或更新",
      triangleTips: "可以自由地发布任何内容，进行开放的讨论",
      pendingTips:"用于管理员发布待办事项",
    };
  }
};



// WEBPACK FOOTER //
// ./src/pages/mixins/tipsMixin.js